import { Controller, useFormContext } from "react-hook-form";
import { Box, Button, CircularProgress, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from "@mui/material";
import DisplayRateio from "./DisplayRateio";
import { enqueueSnackbar } from "notistack";

export default function Step03() {

    const { getValues, handleSubmit, control, watch } = useFormContext()
    const handleBack = getValues('funcoesAux.onBack')
    const onSubmit = getValues('funcoesAux.onSubmit')
    const addRateio = watch('step03.add_rateio') === 'true'
    const isLoading = watch('isLoadingIncluirLancamento')

    const valoresSelect = [
        { value: 'true', label: 'Sim' },
        { value: 'false', label: 'Não' }
    ]

        const handleAvancar = (data: any) => {
            const { step03 } = getValues()
            if (step03.add_rateio === 'true' && step03.rateios.length <= 1) {
                enqueueSnackbar("É necessário informar pelo menos um centro de custos", { variant: "warning" })
                return
            }
            onSubmit(data)
        }

    return (
        <Grid container spacing={2}>
            <Grid size={{xs: 12}}>
                <Controller
                    name="step03.add_rateio"
                    control={control}
                    rules={{ required: 'Campo obrigatório' }}
                    render={({ field }) => (
                        <FormControl fullWidth>
                            <FormLabel id={`adicionar-rateio`}>
                                Deseja dividir o valor em mais de um centro de custo?
                            </FormLabel>

                            <RadioGroup
                                {...field}
                                row
                                aria-labelledby="rateio-radio"
                            >
                                {
                                    valoresSelect.map((opcao, index) => (
                                        <FormControlLabel
                                            key={index}
                                            value={opcao.value}
                                            control={<Radio />}
                                            label={opcao.label}
                                        />
                                    ))
                                }
                            </RadioGroup>
                        </FormControl>
                    )}
                />
            </Grid>

            {
                addRateio && (
                    <Grid size={{xs: 12}}>
                        <DisplayRateio />
                    </Grid>
                )
            }

            <Grid size={{xs: 12}}>
                <Box display={'flex'} gap={2}>
                    <Button
                        variant="outlined"
                        onClick={handleBack}
                    >
                        Voltar
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSubmit(handleAvancar)}
                        disabled={isLoading}
                    >
                        {
                            isLoading &&
                            <CircularProgress size={20} sx={{ marginRight: 1 }} />
                        }
                        Finalizar
                    </Button>
                </Box>
            </Grid>
        </Grid>
    )
}